(function() {
  $(document).ready(function() {
    window['wc-pickup-options-suppress'] = true;
    var elmts = document.querySelectorAll('#cart_agree');
    function toggle(event) {
      var elm = event.currentTarget;
      var btns = elm.closest('form').querySelectorAll('.btn-checkout, .btn_checkout');
      if (elm.checked) {
        window['wc-pickup-options-suppress'] = false;
      } else {
        window['wc-pickup-options-suppress'] = true;
      }
    }
    for (var i = 0; i < elmts.length; i++) {
      var elm = elmts[i];
      elm.addEventListener('change', toggle);
    }
  }); 
}());